import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import Fein from "../../../../gdk/Fein";
import { classes } from "../../../../../util/style-utils";

export default function AgencyGroupInformation() {
    const { register, watch, formState: { errors }, control, setValue } = useFormContext();

    const watchAffiliatedWithTop100 = watch("affiliatedWithTop100");
    const watchFirmNetworkOrAggregator = watch("firmNetworkOrAggregator");
    const watchFirmNetworkAggregatorCommissionPayments = watch("firmNetworkAggregatorCommissionPayments");

    const showAgencyGroupInformation = useMemo(() => (
        watchAffiliatedWithTop100 === "true" &&
        watchFirmNetworkOrAggregator &&
        watchFirmNetworkAggregatorCommissionPayments === "true"
    ), [
        watchAffiliatedWithTop100,
        watchFirmNetworkOrAggregator,
        watchFirmNetworkAggregatorCommissionPayments
    ]);

    useEffect(() => {
        if (watchFirmNetworkAggregatorCommissionPayments === "true") {
            setValue("agencyGroupName", watchFirmNetworkOrAggregator?.[0]);
        }
    }, [watchFirmNetworkAggregatorCommissionPayments, watchFirmNetworkOrAggregator, setValue]);

    useEffect(() => {
        if (!showAgencyGroupInformation) {
            setValue("agencyGroupName", "");
            setValue("agencyGroupFEIN", "");
            setValue("agencyGroupEmailAddress", "");
        }
    }, [showAgencyGroupInformation, setValue]);

    return <>
        {showAgencyGroupInformation &&
            <>
                <div className="flex-row">
                    <div className={classes("form-field", errors.agencyGroupName && "form-field--error")}>
                        <label htmlFor="agency-group-name" className="text">
                            Agency Group Name{/*
                            */}<span className='required'>*</span>
                        </label>
                        <input id="agency-group-name" type="text" {...register("agencyGroupName")} />
                        {errors.agencyGroupName &&
                            <span className="form-message">{errors.agencyGroupName.message}</span>
                        }
                    </div>

                    <Fein
                        control={control}
                        name="agencyGroupFEIN"
                        label={<>
                            Agency Group FEIN{/*
                            */}<span className='required'>*</span>
                        </>}
                    />
                </div>

                <div className={classes("form-field", errors.agencyGroupEmailAddress && "form-field--error")}>
                    <label htmlFor="agency-group-email-address" className="text">
                        Agency Group Email Address{/*
                        */}<span className='required'>*</span>
                    </label>
                    <input id="agency-group-email-address" type="email" {...register("agencyGroupEmailAddress")} />
                    {errors.agencyGroupEmailAddress &&
                        <span className="form-message">{errors.agencyGroupEmailAddress.message}</span>
                    }
                </div>
            </>
        }
    </>
}